import ContentService from '@/services/ContentService'
import ChangeController from '@/components/admin/ChangeController'

import Messages from '@/helpers/message-helper'

export default {
	data() {
		return {
			data: {},
			dataChanged: false
		}
	},
	components: {
		ChangeController
	},
	async created() {
		this.load()
	},
	methods: {
		async load() {
			this.$emit('show-message', Messages.LOADING)

			const { contentId } = this.$router.currentRoute.meta
			this.data = await ContentService.get(contentId)

			this.$emit('show-message', Messages.SUCCESS('loaded'))
			if (!this.data.files) this.$set(this.data, 'files', [])

			this.dataChanged = false
		},
		async save() {
			this.$emit('show-message', Messages.SAVING)

			try {
				let result = await ContentService.save(this.data)

				if (result.message) this.$emit('show-message', Messages.INFO(result.message))
				else this.$emit('show-message', Messages.SUCCESS('saved'))

				this.dataChanged = false
			} catch (error) {
				// debugger
				this.$emit('show-message', Messages.ERROR(error))
			}
		},
		async revert() {
			this.load()
		}
	}
}
